/**
 *
 * Asynchronously loads the component for AssetByGoal
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetByGoal = lazyLoad(
  () => import('./index'),
  module => module.AssetByGoal,
);
